import { RemoteError } from 'app/design/primitives/remote-error';
import type { TFunction } from 'i18next';

export function buildError(t: TFunction, error: Error) {
  const errorMessage = (error as any)?.response?.data?.message;
  let localizedError: string | undefined = t(errorMessage as string, { ns: 'api-errors' });
  if (localizedError === errorMessage) {
    localizedError = undefined;
  }
  if (!localizedError) {
    const httpStatusCode = (error as any)?.response?.data?.statusCode;
    if (httpStatusCode === 403) {
      localizedError = t('modal.error.forbidden', { ns: 'my-plan' });
    } else if (httpStatusCode === 404) {
      localizedError = t('modal.error.invalidCode', { ns: 'my-plan' });
    } else if (httpStatusCode === 406) {
      localizedError = t('modal.error.codeLimitReached', { ns: 'my-plan' });
    }
  }
  return <RemoteError error={error} message={localizedError} />;
}
